/** Google Form embed URL shared by Feedback and Contact pages. */
export const FEEDBACK_FORM_EMBED_SRC =
  "https://docs.google.com/forms/d/e/1FAIpQLSfG9t_sFqGPWSw8GCMOAbVj9jXyOCQ_--9tI0ad0HTQ4CUaZA/viewform?embedded=true";
